export default __webpack_public_path__ + "static/media/Version (7) - Snape Insult_04.52b060aa.jpg";